import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '@/context/SiteContext';

export const AboutPage = () => {
  const { siteData } = useSite();

  return (
    <div className="min-h-screen bg-background">
      <div className="bg-muted/30 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center gap-2 text-sm text-muted-foreground">
            <Link to="/" className="hover:text-primary transition-colors">Início</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Sobre Nós</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">Sobre a Festa Encantada</h1>
        
        <div className="prose prose-lg text-muted-foreground space-y-6">
          <p>
            Bem-vindo à <strong className="text-foreground">Festa Encantada</strong>! Somos uma loja especializada 
            em artigos para festas e decoração, dedicada a tornar cada celebração num momento mágico e inesquecível.
          </p>

          <p>
            O nosso lema, <em>"{siteData?.slogan}"</em>, reflete o nosso compromisso em oferecer 
            produtos de qualidade que transformam qualquer festa numa experiência especial.
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">O que oferecemos</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Balões de todos os tipos e cores</li>
            <li>Artigos descartáveis temáticos</li>
            <li>Decoração para todas as ocasiões</li>
            <li>Velas decorativas e musicais</li>
            <li>Pinhatas divertidas</li>
            <li>Confettis e lançadores</li>
            <li>Lembranças e brindes</li>
            <li>Kits festa completos</li>
          </ul>

          <h2 className="text-xl font-bold text-foreground mt-8">Como encomendar</h2>
          <p>
            Navega pelo nosso site, adiciona os produtos ao carrinho e finaliza a encomenda 
            via WhatsApp. É simples, rápido e personalizado!
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Levantamento</h2>
          <p>
            Podes levantar a tua encomenda na nossa morada:{' '}
            <strong className="text-foreground">{siteData?.pickup?.fullAddress}</strong>.
            As encomendas ficam prontas em aproximadamente 1 hora.
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Contactos</h2>
          <p>
            WhatsApp: <a href={siteData?.contact?.whatsappLink} className="text-primary hover:underline">
              {siteData?.contact?.whatsappDisplay}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export const ReturnsPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="bg-muted/30 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center gap-2 text-sm text-muted-foreground">
            <Link to="/" className="hover:text-primary transition-colors">Início</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Trocas e Devoluções</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">Trocas e Devoluções</h1>
        
        <div className="prose prose-lg text-muted-foreground space-y-6">
          <p>
            Na Festa Encantada, queremos que fiques 100% satisfeito com a tua compra.
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Política de Trocas</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Aceitamos trocas até 14 dias após a compra</li>
            <li>Os produtos devem estar na embalagem original e sem uso</li>
            <li>Contacta-nos via WhatsApp para agendar a troca</li>
          </ul>

          <h2 className="text-xl font-bold text-foreground mt-8">Devoluções</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Reembolsos são processados após a verificação do produto</li>
            <li>O prazo de reembolso é de até 7 dias úteis</li>
            <li>Produtos personalizados não são elegíveis para devolução</li>
          </ul>

          <h2 className="text-xl font-bold text-foreground mt-8">Produtos com Defeito</h2>
          <p>
            Se receberes um produto com defeito, contacta-nos imediatamente via WhatsApp 
            com fotos do problema. Faremos a troca ou reembolso sem custos adicionais.
          </p>
        </div>
      </div>
    </div>
  );
};

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="bg-muted/30 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center gap-2 text-sm text-muted-foreground">
            <Link to="/" className="hover:text-primary transition-colors">Início</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Política de Privacidade</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">Política de Privacidade</h1>
        
        <div className="prose prose-lg text-muted-foreground space-y-6">
          <p>
            A Festa Encantada está comprometida com a proteção da tua privacidade e dos teus dados pessoais.
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Dados Recolhidos</h2>
          <p>Recolhemos apenas os dados necessários para processar as tuas encomendas:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Nome</li>
            <li>Número de telefone</li>
            <li>Morada de entrega (se aplicável)</li>
          </ul>

          <h2 className="text-xl font-bold text-foreground mt-8">Uso dos Dados</h2>
          <p>Os teus dados são utilizados exclusivamente para:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Processar e entregar as tuas encomendas</li>
            <li>Comunicar sobre o estado da encomenda</li>
            <li>Prestar apoio ao cliente</li>
          </ul>

          <h2 className="text-xl font-bold text-foreground mt-8">Armazenamento Local</h2>
          <p>
            Utilizamos localStorage no teu navegador para guardar o carrinho de compras 
            e a lista de favoritos, melhorando a tua experiência de navegação.
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Os Teus Direitos</h2>
          <p>
            Tens o direito de aceder, corrigir ou eliminar os teus dados pessoais. 
            Contacta-nos via WhatsApp para qualquer pedido relacionado com os teus dados.
          </p>
        </div>
      </div>
    </div>
  );
};

export const TermsPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="bg-muted/30 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center gap-2 text-sm text-muted-foreground">
            <Link to="/" className="hover:text-primary transition-colors">Início</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Termos e Condições</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">Termos e Condições</h1>
        
        <div className="prose prose-lg text-muted-foreground space-y-6">
          <p>
            Ao utilizar o site da Festa Encantada, aceitas os seguintes termos e condições.
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Encomendas</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>As encomendas são confirmadas via WhatsApp</li>
            <li>Os preços apresentados são em Euros (€) e incluem IVA</li>
            <li>A disponibilidade dos produtos está sujeita ao stock existente</li>
          </ul>

          <h2 className="text-xl font-bold text-foreground mt-8">Entregas</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Portes de envio: 5,00 € (Grátis a partir de 50,00 €)</li>
            <li>Levantamento gratuito na nossa morada</li>
            <li>Prazos de entrega comunicados via WhatsApp</li>
          </ul>

          <h2 className="text-xl font-bold text-foreground mt-8">Pagamentos</h2>
          <p>
            O método de pagamento será acordado via WhatsApp no momento da confirmação da encomenda.
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Responsabilidade</h2>
          <p>
            As imagens dos produtos são ilustrativas. Podem existir pequenas variações 
            de cor ou design em relação ao produto real.
          </p>
        </div>
      </div>
    </div>
  );
};

export const ContactPage = () => {
  const { siteData } = useSite();

  return (
    <div className="min-h-screen bg-background">
      <div className="bg-muted/30 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center gap-2 text-sm text-muted-foreground">
            <Link to="/" className="hover:text-primary transition-colors">Início</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Contactos</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">Contactos</h1>
        
        <div className="prose prose-lg text-muted-foreground space-y-6">
          <h2 className="text-xl font-bold text-foreground">WhatsApp</h2>
          <p>
            A forma mais rápida de nos contactar é via WhatsApp:{' '}
            <a href={siteData?.contact?.whatsappLink} className="text-primary hover:underline font-semibold">
              {siteData?.contact?.whatsappDisplay}
            </a>
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Morada de Levantamento</h2>
          <p>
            <strong className="text-foreground">{siteData?.pickup?.name}</strong><br />
            {siteData?.pickup?.fullAddress}
          </p>

          <h2 className="text-xl font-bold text-foreground mt-8">Redes Sociais</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <a href={siteData?.socialLinks?.instagram} className="text-primary hover:underline">
                Instagram
              </a>
            </li>
            <li>
              <a href={siteData?.socialLinks?.facebook} className="text-primary hover:underline">
                Facebook
              </a>
            </li>
          </ul>

          <h2 className="text-xl font-bold text-foreground mt-8">Horário de Atendimento</h2>
          <p>
            Respondemos às mensagens de segunda a sábado, das 10h às 19h.
          </p>
        </div>
      </div>
    </div>
  );
};
